import { NavigationItem } from './navigation.model';

export const defaultNavigation: NavigationItem[] = [
  // ─── Commercial — Customer-Facing ───
  {
    id: 'group-commercial',
    title: 'Navigation.Groups.Commercial',
    shortTitle: 'COM',
    type: 'group',
    children: [
      {
        id: 'POS',
        title: 'Navigation.StoreManagement',
        type: 'basic',
        icon: 'design:restaurant',
        materialIcon: 'storefront',
        link: '/pos',
      },
      {
        id: 'SM',
        title: 'Navigation.SalesManagement',
        type: 'collapsable',
        icon: 'design:cart',
        materialIcon: 'shopping_cart',
        link: '/sales',
        children: [
          {
            id: 'SM-SAL-CT',
            title: 'Navigation.ControlTower',
            type: 'basic',
            materialIcon: 'dashboard',
            link: '/sales/control-tower',
          },
          {
            id: 'SM-SAL-SOV2',
            title: 'Navigation.SalesOrders',
            type: 'basic',
            materialIcon: 'receipt',
            link: '/sales/order',
          },
          {
            id: 'SM-SAL-INV',
            title: 'Navigation.SalesInvoices',
            type: 'basic',
            materialIcon: 'receipt_long',
            link: '/sales/invoice',
          },
          {
            id: 'SM-SAL-QT',
            title: 'Navigation.Quotations',
            type: 'basic',
            materialIcon: 'request_quote',
            link: '/sales/quotation',
          },
          {
            id: 'SM-SAL-SC',
            title: 'Navigation.SalesContracts',
            type: 'basic',
            materialIcon: 'handshake',
            link: '/sales/sales-contract',
          },
          {
            // SCP-PREPAY-S6 (quyết định #17): màn CustomerPayment hạ dần — mục menu giữ id
            // (mã resource RBAC) nhưng trỏ sang phiếu thu hợp nhất.
            id: 'SM-SAL-CP',
            title: 'Navigation.Receipt',
            type: 'basic',
            materialIcon: 'payments',
            link: '/sales/accounting/receipt',
          },
          {
            id: 'SM-SAL-CUS',
            title: 'Navigation.ContactSale',
            type: 'basic',
            icon: 'design:customer',
            materialIcon: 'person',
            link: '/sales/customer',
          },
        ],
      },
      {
        id: 'CRM',
        title: 'Navigation.CRM',
        type: 'basic',
        icon: 'design:client_group',
        materialIcon: 'contacts',
        link: '/crm',
      },
    ],
  },
  // ─── Supply Chain — Order to Fulfillment ───
  {
    id: 'group-supply-chain',
    title: 'Navigation.Groups.SupplyChain',
    shortTitle: 'SCM',
    type: 'group',
    children: [
      {
        id: 'WM',
        title: 'Navigation.WarehouseManagement',
        type: 'collapsable',
        icon: 'design:sale_inventory',
        materialIcon: 'home_storage',
        link: '/warehouse',
        children: [
          {
            id: 'WH-DASH',
            title: 'Navigation.WarehouseControlTower',
            type: 'basic',
            materialIcon: 'speed',
            link: '/warehouse/control-tower',
          },
          {
            id: 'WM-INB',
            title: 'Navigation.InboundOutbound',
            type: 'basic',
            materialIcon: 'swap_vert',
            link: '/warehouse/inbound-outbound',
          },
          {
            id: 'WM-GR',
            title: 'Navigation.GoodsReceipt',
            type: 'basic',
            materialIcon: 'inventory',
            link: '/warehouse/goods-receipt',
          },
          {
            id: 'WM-GI',
            title: 'Navigation.GoodsIssue',
            type: 'basic',
            materialIcon: 'outbound',
            link: '/warehouse/goods-issue',
          },
          {
            id: 'WM-ST',
            title: 'Navigation.StockTransfer',
            type: 'basic',
            materialIcon: 'swap_horiz',
            link: '/warehouse/stock-transfer',
          },
          {
            id: 'WM-RN',
            title: 'Navigation.ReturnNote',
            type: 'basic',
            materialIcon: 'assignment_return',
            link: '/warehouse/return-note',
          },
          {
            id: 'WM-IB',
            title: 'Navigation.InventoryBalance',
            type: 'basic',
            icon: 'mat_outline:inventory',
            materialIcon: 'inventory',
            link: '/warehouse/inventory-balance',
          },
          {
            id: 'WM-APR-WF',
            title: 'Navigation.WarehouseApprovalQueue',
            type: 'basic',
            materialIcon: 'verified_user',
            link: '/warehouse/approval',
          },
          {
            id: 'WM-GLP',
            title: 'Navigation.WarehouseGLPosting',
            type: 'basic',
            materialIcon: 'account_balance',
            link: '/warehouse/gl-posting',
          },
        ],
      },
      {
        id: 'LM',
        title: 'Navigation.LogisticManagement',
        type: 'basic',
        icon: 'design:sale_delivery',
        materialIcon: 'local_shipping',
        link: '/logistics',
      },
      {
        id: 'PROC',
        title: 'Navigation.Procurement',
        type: 'basic',
        icon: 'design:supply_chain',
        materialIcon: 'shopping_bag',
        link: '/procurement',
      },
      {
        id: 'PLAN',
        title: 'Navigation.Planning',
        type: 'basic',
        icon: 'mat_outline:event_note',
        materialIcon: 'calendar_month',
        link: '/planning',
      },
      {
        id: 'MFG',
        title: 'Navigation.ManufacturingManagement',
        type: 'basic',
        icon: 'design:factory',
        materialIcon: 'present_to_all',
        link: '/manufacturing',
      },
    ],
  },
  // ─── Finance — Financial Management ───
  {
    id: 'group-finance',
    title: 'Navigation.Groups.Finance',
    shortTitle: 'FIN',
    type: 'group',
    children: [
      {
        id: 'FIN',
        title: 'Navigation.FinanceManagement',
        type: 'basic',
        icon: 'mat_outline:account_balance',
        materialIcon: 'account_balance',
        link: '/finance',
      },
      {
        id: 'PRICING',
        title: 'Navigation.Pricing',
        type: 'basic',
        icon: 'mat_outline:sell',
        materialIcon: 'account_balance_wallet',
        link: '/pricing',
      },
      {
        id: 'AM',
        title: 'Navigation.AssetManagement',
        type: 'basic',
        icon: 'mat_outline:business_center',
        materialIcon: 'business_center',
        link: '/asset-management',
      },
    ],
  },
  // ─── Operations — People & Projects ───
  {
    id: 'group-operations',
    title: 'Navigation.Groups.Operations',
    shortTitle: 'OPS',
    type: 'group',
    children: [
      {
        id: 'HRM',
        title: 'Navigation.HRM',
        type: 'basic',
        icon: 'mat_outline:badge',
        materialIcon: 'groups',
        link: '/hrm',
      },
      {
        id: 'PM',
        title: 'Navigation.ProjectManagement',
        type: 'basic',
        icon: 'mat_outline:work_outline',
        materialIcon: 'view_kanban',
        link: '/project-management',
      },
      {
        id: 'OKR',
        title: 'Navigation.OkrKpi',
        type: 'basic',
        icon: 'mat_outline:emoji_events',
        materialIcon: 'trending_up',
        link: '/okr-kpi',
      },
    ],
  },
  // ─── Foundation — Platform Base ───
  {
    id: 'group-foundation',
    title: 'Navigation.Groups.Foundation',
    shortTitle: 'FDN',
    type: 'group',
    children: [
      {
        id: 'MD',
        title: 'Navigation.MasterData.Title',
        type: 'basic',
        icon: 'mat_outline:dataset',
        materialIcon: 'database',
        link: '/master-data',
      },
      {
        id: 'SEC',
        title: 'Navigation.Security',
        type: 'basic',
        icon: 'mat_outline:gpp_good',
        materialIcon: 'verified_user',
        link: '/security',
      },
      {
        id: 'AC',
        title: 'Navigation.Administration',
        type: 'basic',
        icon: 'mat_outline:settings',
        materialIcon: 'settings',
        link: '/administration',
      },
    ],
  },
  // ─── Enterprise — Governance & Platform ───
  {
    id: 'group-enterprise',
    title: 'Navigation.Groups.Enterprise',
    shortTitle: 'ENT',
    type: 'group',
    children: [
      {
        id: 'GOV',
        title: 'Navigation.Governance',
        type: 'basic',
        icon: 'mat_outline:policy',
        materialIcon: 'policy',
        link: '/governance',
      },
      {
        id: 'RISK',
        title: 'Navigation.RiskManagement',
        type: 'basic',
        icon: 'mat_outline:shield',
        materialIcon: 'shield',
        link: '/risk',
      },
      {
        id: 'FUSION',
        title: 'Navigation.Fusion',
        type: 'basic',
        icon: 'mat_outline:rule',
        materialIcon: 'account_tree',
        link: '/fusion/dashboard',
      },
      {
        id: 'PLAT',
        title: 'Navigation.Platform',
        type: 'basic',
        icon: 'mat_outline:terminal',
        materialIcon: 'terminal',
        link: '/platform',
      },
    ],
  },
  // ─── Hub — Personal & Knowledge ───
  {
    id: 'group-hub',
    title: 'Navigation.Groups.Hub',
    shortTitle: 'HUB',
    type: 'group',
    children: [
      {
        id: 'PROFILE',
        title: 'Navigation.Profile',
        type: 'basic',
        icon: 'mat_outline:person',
        materialIcon: 'person',
        link: '/profile',
      },
      {
        id: 'KB',
        title: 'Navigation.KnowledgeHub',
        type: 'basic',
        icon: 'mat_outline:auto_stories',
        materialIcon: 'menu_book',
        link: '/knowledge',
      },
      {
        id: 'COMP-LIB',
        title: 'Navigation.ComponentLibrary',
        type: 'basic',
        icon: 'mat_outline:palette',
        materialIcon: 'palette',
        link: '/component-library',
      },
      {
        id: 'TEST-CENTER',
        title: 'Navigation.TestCenter',
        type: 'basic',
        icon: 'mat_outline:science',
        materialIcon: 'science',
        link: '/test-center',
      },
    ],
  },
];
